import { motion } from "framer-motion";
import { GraduationCap, Stethoscope } from "lucide-react";

const doctors = [
    {
        name: "Dr. Hitesh Khatri",
        role: "Chief Consultant Dermatologist",
        credential: "MBBS, MD (Dermatology, Venereology & Leprosy)",
        bio: "Dr. Hitesh leads Mirrari's dermatology practice with a calm, evidence-first approach to acne, pigmentation, hair restoration and venereology care.",
        specialties: ["Acne & Scars", "Pigmentation", "PRP Hair & Skin", "Venereology"],
        image: "/images/dr-hitesh-khatri.jpg",
        icon: Stethoscope,
    },
    {
        name: "Dr. Chitra Sachdev",
        role: "Consultant Dental Surgeon",
        credential: "BDS, MDS (Endodontics)",
        bio: "Dr. Chitra is an endodontist specialising in root canal therapy and smile-design dentistry — renowned for precise, pain-minimised treatment.",
        specialties: ["Endodontics", "Cosmetic Dentistry", "Smile Makeover", "General Dental"],
        image: "/images/dr-chitra-sachdev.jpg",
        icon: GraduationCap,
    },
];

export default function Doctors() {
    return (
        <section
            id="doctors"
            className="py-24 md:py-32"
            data-testid="doctors-section"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.6 }}
                    className="max-w-3xl"
                >
                    <span className="text-xs uppercase tracking-[0.3em] text-[#8A9A5B] font-medium">
                        — Meet The Team
                    </span>
                    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-light text-[#1A221F] mt-4 leading-[1.1] tracking-tight">
                        Specialists who <em className="italic text-[#3B5249]">listen</em> first.
                    </h2>
                </motion.div>

                <div className="grid md:grid-cols-2 gap-8 mt-16">
                    {doctors.map((d, i) => (
                        <motion.div
                            key={d.name}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{ duration: 0.6, delay: i * 0.1 }}
                            className="group bg-white rounded-[2rem] border border-[#E8E6E1] overflow-hidden shadow-[0_8px_30px_rgba(0,0,0,0.04)] hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)] transition-all duration-500"
                            data-testid={`doctor-card-${i}`}
                        >
                            <div className="grid sm:grid-cols-5 h-full">
                                <div className="sm:col-span-2 relative aspect-square sm:aspect-auto overflow-hidden bg-[#F3F1EC]">
                                    <img
                                        src={d.image}
                                        alt={d.name}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms]"
                                    />
                                </div>
                                <div className="sm:col-span-3 p-7 md:p-9 flex flex-col">
                                    <div className="w-11 h-11 rounded-2xl bg-[#F3F1EC] flex items-center justify-center mb-5">
                                        <d.icon className="w-5 h-5 text-[#3B5249]" />
                                    </div>
                                    <h3 className="font-display text-2xl text-[#1A221F] font-medium">
                                        {d.name}
                                    </h3>
                                    <p className="text-sm text-[#3B5249] mt-1 font-medium">
                                        {d.role}
                                    </p>
                                    <p className="text-xs text-[#7A8C84] mt-1 uppercase tracking-wider">
                                        {d.credential}
                                    </p>
                                    <p className="text-sm text-[#4A5D54] mt-4 leading-relaxed">
                                        {d.bio}
                                    </p>
                                    <div className="flex flex-wrap gap-2 mt-5 pt-5 border-t border-[#E8E6E1]">
                                        {d.specialties.map((s) => (
                                            <span
                                                key={s}
                                                className="text-xs px-3 py-1 rounded-full bg-[#F3F1EC] text-[#4A5D54]"
                                            >
                                                {s}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
